<script>
import CaregiverBehaviorRating from '@/components/caregiver/CaregiverBehaviorRating.vue'
import CaregiverBehaviorTable from '@/components/caregiver/CaregiverBehaviorTable.vue'
import CaregiverBehaviorRatingModel from '@/model/CaregiverBehaviorRatingModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  mixins: [GenericAPIHandler],
  components: {
    CaregiverBehaviorRating,
    CaregiverBehaviorTable
  },
  props: {
    caregiverId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      dashboard: {
        badFeedbacks: 0,
        goodFeedbacks: 0,
        ratings: 0,
      },
    }
  },
  methods: {
    async getDashboard () {
      try {
        const raw = await this.$api.Caregiver.behaviorDashboard(this.caregiverId)
        this.dashboard = CaregiverBehaviorRatingModel.fromJSON(raw)
      } catch (error) {
        this.showErrorDialog(error)
      }
    }
  },
}
</script>

<template>
  <el-row class="caregiver-behavior-container">
    <CaregiverBehaviorRating :detail="dashboard"/>
    <CaregiverBehaviorTable
      :caregiverId="caregiverId"
      @getDashboard="getDashboard"
    />
  </el-row>
</template>

<style scoped lang="scss">
  .caregiver-behavior-container {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;

  }
</style>
